module.exports = __webpack_public_path__ + "static/media/8.050494c6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/galeria/8.jpeg
// module id = 161
// module chunks = 0